<script>
import NotificationModal from './NotificationModal.vue'
import { Helper } from '@/mixin/helper'

export default {
  name: 'NotificationIcon',

  components: {
    NotificationModal,
  },

  mixins: [Helper],

  created() {
    this.getNotifications()
  },

  computed: {
    notifications() {
      return this.$store.state.notification.notifications
    },

    unreadCount() {
      return this.$store.getters['notification/unreadCount']
    },
  },

  watch: {
    $route() {
      this.$refs.notificationDropdown?.hide()
    }
  },

  methods: {
    onDropdownShow() {
      this.getNotifications()
    },

    viewAllNotifications() {
      this.$router.push({ name: 'notifications' })
    },

    getNotifications() {
      const userId = this.getUserId()
      const params = {
        filters: [`user_id eq ${userId}`],
        limit: 10,
        page: 1,
        sort: ['sorts desc']
      }
      this.$store.dispatch('notification/fetchNotifications', params)
      this.$store.dispatch('notification/fetchUnreadCount', userId)
    },

    markAsRead(id) {
      this.$store.dispatch('notification/markNotificationRead', id)
    },

    markAllAsRead() {
      this.$store.dispatch('notification/markAllNotificationsRead')
    },

    closeDropdown() {
      this.$refs.notificationDropdown.hide()
    }
  },
}
</script>

<template>
  <b-dropdown ref="notificationDropdown" right menu-class="dropdown-menu-end" toggle-class="header-item noti-icon"
    variant="black" class="mc-notification__icon" no-caret @show="onDropdownShow">
    <template v-slot:button-content>
      <i class="bx bx-bell"></i>
      <span v-if="unreadCount > 0" class="badge bg-danger rounded-pill">{{ unreadCount }}</span>
    </template>

    <NotificationModal :notifications="notifications" @close="closeDropdown" @mark-all-read="markAllAsRead"
      @mark-read="markAsRead" @view-all="viewAllNotifications" />
  </b-dropdown>
</template>
